import { render, staticRenderFns } from "./AvatarWithBadge.vue?vue&type=template&id=8219f4b0&"
import script from "./AvatarWithBadge.vue?vue&type=script&lang=js&"
export * from "./AvatarWithBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports